/* eslint-disable @typescript-eslint/no-explicit-any */
import { STRINGS } from 'config';
import { marked } from 'marked';

marked.setOptions({
  breaks: true, // Treat single line breaks as <br>
});

const {
  COPILOT: {
    COPILOT_QUERY_REQUEST,
    COPILOT_QUERY_SUCCESS,
    COPILOT_QUERY_FAILURE,
    UPDATE_QUERY,
    RESET_COPILOT_QUERY_AND_RESPONSE,
    CLEAR_COPILOT_RESPONSE,
    COPILOT_LETTER_SUMMARY_SUCCESS,
    CLEAR_LETTER_SUMMARY,
  },
} = STRINGS.REDUCERS;

export interface CopilotState {
  isQueryRequestSent: boolean;
  queryMessage: string;
  response: string;
  letterSummary: string;
  error?: string | null;
}

type CopilotAction =
  | { type: typeof COPILOT_QUERY_REQUEST }
  | { type: typeof COPILOT_QUERY_SUCCESS; payload: string }
  | { type: typeof COPILOT_QUERY_FAILURE; error: string }
  | { type: typeof UPDATE_QUERY; payload: string }
  | { type: typeof RESET_COPILOT_QUERY_AND_RESPONSE }
  | { type: typeof COPILOT_LETTER_SUMMARY_SUCCESS; payload: string }
  | { type: typeof CLEAR_LETTER_SUMMARY };

export const initialCopilotState: CopilotState = {
  isQueryRequestSent: false,
  queryMessage: '',
  response: '',
  letterSummary: '',
  error: null,
};

export const copilotReducer = (state: CopilotState, action: CopilotAction): CopilotState => {
  switch (action.type) {
    case COPILOT_QUERY_REQUEST:
      return {
        ...state,
        isQueryRequestSent: true,
        error: null,
      };
    case COPILOT_QUERY_SUCCESS:
      if ('payload' in action) {
        const htmlSummary = marked.parse(action.payload, { async: false });
        return {
          ...state,
          isQueryRequestSent: false,
          response: htmlSummary,
          error: null,
        };
      }
      return state;
    case COPILOT_QUERY_FAILURE:
      return {
        ...state,
        isQueryRequestSent: false,
        error: 'error' in action ? action.error : null,
        response: '',
      };
    case UPDATE_QUERY:
      return {
        ...state,
        queryMessage: 'payload' in action ? action.payload : state.queryMessage,
      };
    case CLEAR_COPILOT_RESPONSE:
      return {
        ...state,
        response: '',
        error: null,
      };
    case RESET_COPILOT_QUERY_AND_RESPONSE:
      return {
        ...state,
        queryMessage: initialCopilotState.queryMessage,
        response: '',
        error: null,
      };
    case COPILOT_LETTER_SUMMARY_SUCCESS:
      if ('payload' in action) {
        return {
          ...state,
          isQueryRequestSent: false,
          letterSummary: action.payload,
          error: null,
        };
      }
      return state;
    case CLEAR_LETTER_SUMMARY:
      return {
        ...state,
        letterSummary: '',
      };
    default:
      return state;
  }
};
